import * as React from 'react';
import {observer} from 'mobx-react';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {MultiSuggestWidget} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/MultiSuggestWidget';

@observer
export class EditableMultiSuggestWidget extends React.Component<IWidgetComponentProps, any>
{
    render()
    {
        return <MultiSuggestWidget {...this.props} isEditable={true} />;
    }
}
